import React, {useState} from 'react';
import FanDisplayImage from '../../../assets/img/dashboard/fanMain';
import FanIcon from '../../../assets/img/dashboard/iconFan';
// import PowerIcon from '../../../assets/img/dashboard/powerLarge';

const FanType = ({selectedItem, handlePostData, action}) => {
	const [swing, setSwing] = useState((selectedItem.deviceState && selectedItem.deviceState.swing) ? selectedItem.deviceState.swing : false);
	const [fanSpeed, setFanSpeed] =  useState((selectedItem.deviceState && selectedItem.deviceState.fanSpeed) ? selectedItem.deviceState.swing : false);


	const handleSwing = () =>{
		action();
		setSwing(!swing)
		handlePostData('swing', true);
	}

	
	const handleFanspeed = () => {
		setFanSpeed(!fanSpeed)
		handlePostData('fanSpeed', true);
		action();
	}


	return (
		<>
		<section className="device-setting-body">
			<div className="device-display fan">
				<div className="display">
					<FanDisplayImage/>
				</div>
			</div>

			<div className="device-control-wrap">
				<div className="device-control device-control-flex fan-control">
					<p className="fan-button">
						<span onClick={handleSwing}><FanIcon type={"rotate"}/></span>
						<span>회전</span>
					</p>
					<p className="fan-button">
						<span  onClick={handleFanspeed}><FanIcon type={"fanPower"}/></span>
						<span>풍속</span>
					</p>
				</div>
			</div>
		</section>
	
	</>
	);
}

export default FanType;